export const QEMU_SAVE_CONFIG = "QEMU_SAVE_CONFIG";
